import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AlertMessageComponent, AlertModule as CosoAlertModule } from "@coso/alert";
import { UtilityModule } from "@coso/utility";
import { FormsModule as CosoFormsModule } from "@coso/forms";
import { MonacoEditorModule } from "@materia-ui/ngx-monaco-editor";
import { AlertModule } from "ngx-bootstrap/alert";
import { ButtonsModule } from "ngx-bootstrap/buttons";
import { PopoverModule } from "ngx-bootstrap/popover";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { PageHeaderModule } from "../../page-header/page-header.module";
import { BoardComponent } from "./components/board/board.component";
import { FolderSettingsComponent } from "./components/folder-settings/folder-settings.component";
import { GeneralSettingsComponent } from "./components/general-settings/general-settings.component";
import { LibrarySettingsComponent } from "./components/library-settings/library-settings.component";
import { ScriptEditorComponent } from "./components/script-editor/script-editor.component";
import { ScriptTesterComponent } from "./components/script-tester/script-tester.component";
import { SiteCollectionSettingsComponent } from "./components/site-collection-settings/site-collection-settings.component";
import { SiteSettingsComponent } from "./components/site-settings/site-settings.component";
import { SharePointStructureCreatorService } from "./services/sharepoint-structure-creator.service";
import { SharePointStructureCreatorRoutingModule } from "./sharepoint-structure-creator-routing.module";
import { SharePointStructureCreatorComponent } from "./sharepoint-structure-creator.component";
import { CosoTokenActivation } from "@coso/saas-angular";

@NgModule({
  declarations: [
    SharePointStructureCreatorComponent,
    BoardComponent,
    ScriptEditorComponent,
    ScriptTesterComponent,
    FolderSettingsComponent,
    LibrarySettingsComponent,
    SiteSettingsComponent,
    SiteCollectionSettingsComponent,
    GeneralSettingsComponent
  ],
  imports: [
    CommonModule,
    SharePointStructureCreatorRoutingModule,
    PageHeaderModule,
    AlertModule,
    CosoAlertModule,
    FormsModule,
    PopoverModule,
    MonacoEditorModule,
    UtilityModule,
    TooltipModule,
    ButtonsModule,
    CosoFormsModule,
    ReactiveFormsModule,
    AlertMessageComponent,
    CosoTokenActivation
  ],
  providers: [
    SharePointStructureCreatorService 
  ],
  exports: []
})
export class SharePointStructureCreatorModule {}
